module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "subject-form__reductions"
  }, [(_vm.isLoadingReductions) ? _c('Loader', {
    attrs: {
      "bg-color": '#f6f9fc'
    }
  }) : _c('table', {
    staticClass: "do-table do-table--striped"
  }, [_c('thead', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "td-number td-sum"
  }, [_vm._v(_vm._s(_vm.totalReductionHours))])]), _vm._v(" "), _c('tbody', [(_vm.subjectReductionsSorted.length === 0) ? _c('tr', [_c('p', {
    staticClass: "pad-1 italic"
  }, [_vm._v("Ingen reduktioner")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.subjectReductionsSorted), function(subjectReduction) {
    return _c('tr', {
      key: subjectReduction.id
    }, [_c('td', [_vm._v("\n        " + _vm._s(subjectReduction.vActivityTitle) + " (" + _vm._s(subjectReduction.vActivityReductionHours) + ")\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "td-number"
    }, [_vm._v(_vm._s(subjectReduction.vFormattedHours))])])
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cde8ebf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormReductions.vue
// module id = 1528
// module chunks = 1